class ConstructorReco extends ConstructorBase {
  static OBSERVER_ROOT_MARGIN = '150px';

  constructor() {
    super();
    this.status = 'PENDING';
  }

  connectedCallback() {
    this.productsContainer = this.querySelector('.js-container-for-products');
    this.productsToShow = parseInt(this.getAttribute('products-to-show'), 10) || 10;
    this.productType = this.getAttribute('product-type') || '';
    this.fallbackUrl = this.getAttribute('fallback-url') || '';
    this.excludedHandles = this.getAttribute('excluded-handles')?.split('+').filter(Boolean) || [];

    if (this.status === 'PENDING') {
      this._preloadObserver.observe(this);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._preloadObserver.disconnect();
  }

  _preloadObserver = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        this.classList.add('is-observed');
        this._preloadObserver.disconnect();

        if (!this.productType) {
          console.warn('[ConstructorReco] No product-type attribute set — using Shopify fallback.');
          this._loadShopifyFallback();
        } else {
          this._load();
        }
      }
    },
    { rootMargin: ConstructorReco.OBSERVER_ROOT_MARGIN },
  );

  async _fetchConstructorResults() {
    if (!window.constructorio?.search?.getSearchResults) {
      throw new Error('constructorio.search.getSearchResults is not available');
    }
    return window.constructorio.search.getSearchResults(this.productType);
  }

  _onError() {
    console.error('[ConstructorReco] Failed to load — using Shopify fallback.');
    this._loadShopifyFallback();
  }

  _onNoResults() {
    console.log('[ConstructorReco] No results from Constructor — using Shopify fallback.');
    this._loadShopifyFallback();
  }

  async _loadShopifyFallback() {
    if (!this.fallbackUrl) return;

    try {
      const response = await fetch(this.fallbackUrl);
      if (!response.ok) throw new Error(`Shopify recommendations responded with ${response.status}`);

      const data = await response.json();
      const handles = (data.products || [])
        .map((p) => p.handle)
        .filter(Boolean)
        .map((h) => encodeURIComponent(h));

      if (handles.length > 0) {
        this._fetchAndRenderProducts(handles);
      }
    } catch (error) {
      console.error('[ConstructorReco] Shopify fallback failed:', error);
      this._reportError(error, 'fallback_failed');
    }
  }

  _renderHtml(htmlText) {
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(htmlText, 'text/html');
    const parsedElements = parsedHTML.querySelectorAll('.js-fetched-item');
    const fragment = document.createDocumentFragment();
    parsedElements.forEach((element, index) => {
      element.setAttribute('id', `Slide-constructor-${index + 1}`);
      element.classList.add('product-carousel__slide');
      fragment.appendChild(element);
    });
    this.productsContainer.innerHTML = '';
    window.updateWishlistStateImmediately?.(fragment);
    this.productsContainer.appendChild(fragment);
    this._refreshCarousel();
  }

  _refreshCarousel() {
    this.productsContainer.closest('.product-carousel')?.refresh?.();
  }
}

customElements.define('constructor-reco', ConstructorReco);
